import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../pages/dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { OcidComponent } from './ocid/ocid.component';
import { AuthGuard } from './services/auth-guard.service';
//Teams Intergration
import { ChromelessComponent } from '../pages/chromeless/chromeless.component';
import { DiagnoseComponent } from '../pages/diagnose/diagnose.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'client',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'teams',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'login',
        // DO NOT add AuthGuardService here -- user needs to be able to reach this page regardless 
        component: LoginComponent
    },
    {
        path:'login/ocid',
        // DO NOT add AuthGuardService here -- user needs to be able to reach this page regardless 
        component: OcidComponent
    },
    {
        path: 'dashboard',
        canActivate: [AuthGuard],
        component: DashboardComponent
    },  
    {
        path: 'catalog',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/course-catalog/course-catalog.module').then(m => m.CourseCatalogModule)
    },
    {
        path: 'people',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/people/people.module').then(m => m.PeopleModule)
    },
    {
        path: 'search',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/search/search.module').then(m => m.SearchModule)
    },
    {
        path: 'facilities',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/facilities/facilities.module').then(m => m.FacilitiesModule)
    },
    {
        path: 'styleguide',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/style-guide/style-guide.module').then(m => m.StyleGuideModule)
    },
    {
        path: 'profile',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/profile/profile.module').then(m => m.ProfileModule)
    },
    {
        path: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/content-page/content-page.module').then(m => m.ContentPageModule)
    },
    {
        path: 'document',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/document/document.module').then(m => m.DocumentModule)
    },
    {
        path: 'test',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pages/test/test.module').then(m => m.TestModule)
    },
    //Teams Integration 2021
    {
        path: 'cl',
        canActivate: [AuthGuard],
        component: ChromelessComponent
    },
    {
        path: 'diagnose',
        canActivate: [AuthGuard],
        component: DiagnoseComponent
    },
    {
        path: '**',
        // DO NOT add AuthGuardService here -- user needs to be able to reach this page regardless 
        component: NotFoundComponent
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
